

import React from 'react';
import { useHistory } from 'react-router-dom';
import SearchStatusWidget from '../StatusBar';
import {
  Row,
  Col,
  Container,
  Dropdown,
} from 'react-bootstrap';
import DiscoverLandscape from './DiscoverLandscape';
import { BiSearchAlt } from 'react-icons/bi';
import PageHeader from 'Utils/PageHeader';

// Discover landing — mockup 5a. The old StartSearch card is superseded by
// Actions ▾ → New Discovery (the data-source picker); run history lives in the
// ledger table inside DiscoverLandscape.
const DataDiscovery = () => {
  const history = useHistory();

  return (
    <div>
      <Container fluid>
        <PageHeader
          header='Data Discovery'
          icon={BiSearchAlt}
          tooltip='Discover data on your saved Data Sources.'
          actions={[
            <Dropdown.Item
              key='new-discovery'
              data-testid='discover-action-new-discovery'
              onClick={() => history.push('/sources/pick?action=discover')}
            >
              New Discovery
            </Dropdown.Item>,
          ]}
        />
        <Row aria-level="2" className="widget-row">
          <Col lg="12">
            <DiscoverLandscape />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default DataDiscovery;
export { SearchStatusWidget }
